// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--RNdSK","icon":"a10a3f92e9--icon--dF9uI","info":"a10a3f92e9--info--B_DNZ","message":"a10a3f92e9--message--atDlj"};